import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledPrescriptionHistoryDosageCell = styled(StyledFlex)`
   min-width: 0;
`;

StyledPrescriptionHistoryDosageCell.displayName = 'StyledPrescriptionHistoryDosageCell';
